import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-movement-history-dialog',
  templateUrl: './movement-history-dialog.component.html',
  styleUrls: ['./movement-history-dialog.component.scss']
})
export class MovementHistoryDialogComponent implements OnInit {
  ideaHistory: any = [];
  constructor(
    public dialogRef: MatDialogRef<MovementHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ideaId: number },
    private adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar:MatSnackBar
  ) { }

  ngOnInit() {
    this.getPetitionHistory();
  }
  closeDialog() {
    this.dialogRef.close()
  }
  getPetitionHistory() {
    this._loadingService.register()
    this.adminService.getPetitionHistory(this.data.ideaId).subscribe(res => {
      this._loadingService.resolve();
      const ideaHistories = res.sort((a, b) => {return <any>new Date(a.createdAt) - <any>new Date(b.createdAt)});
      this.ideaHistory = ideaHistories;
    },
    (err) => {
      this._loadingService.resolve();
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    })
  };
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/movement-history-dialog/movement-history-dialog.component.ts